import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: '草民影院的视频画质可以达到什么级别？',
    answer: '草民影院所有影片均提供蓝光1080P高清画质，部分热门影片更支持4K超清画质。我们采用先进的视频编码技术和CDN加速服务，确保您在观看时高清不卡、流畅不缓冲。无论您是在电脑、平板还是手机上观看，都能获得最佳的观影体验。',
  },
  {
    question: '观看视频需要安装播放器或插件吗？',
    answer: '完全不需要！草民影院采用即点即看的在线播放技术，您只需使用任意现代浏览器（Chrome、Edge、Safari等）即可直接观看。无需下载任何播放器、安装任何插件或等待下载，点击播放按钮即可立即开始观影。',
  },
  {
    question: '为什么草民影院的视频播放如此流畅不卡顿？',
    answer: '草民影院在全球范围内部署了多个CDN加速节点，能够根据您的网络位置自动选择最优的服务器进行视频传输。同时，我们的自适应码率技术会根据您的实时网络状况动态调整视频质量，确保在任何网络环境下都能流畅播放，真正做到高清不卡、流畅不缓冲。',
  },
  {
    question: '草民影院的影视资源更新频率如何？',
    answer: '我们拥有专业的内容运营团队，每日更新最新电影和电视剧资源。热门院线大片在影院下映后会第一时间上线，热门电视剧在播出后24小时内完成更新。同时，我们也会不断补充经典老片和冷门佳作，满足不同观众的观影需求。',
  },
  {
    question: '草民影院支持哪些设备观看？',
    answer: '草民影院全面支持电脑（Windows/Mac）、平板（iPad/Android Pad）、手机（iOS/Android）等各类设备。我们的网站采用响应式设计，会根据您的屏幕尺寸自动调整布局，在任何设备上都能获得舒适的观影体验。',
  },
  {
    question: '观看视频需要注册账号或付费吗？',
    answer: '草民影院致力于为广大影迷提供便捷的在线观影体验。您无需注册账号，也无需支付任何费用，即可畅享海量高清电影和超清电视剧。我们相信好的内容应该被更多人看到。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            关于草民影院，你想知道的都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="font-heading font-bold text-foreground-800 text-sm pr-4">
                  {item.question}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-lg text-foreground-500 transition-transform duration-300 ${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}